const ACTION_TYPES = {
  URL: 'url',
  MODAL_OPEN: 'modal_open',
  MODAL_CLOSE: 'modal_close',
};

export { ACTION_TYPES };
